import { Notice } from '@/components/ui/Notice'
import { Section, SectionHeading } from '@/components/ui/Section'
import { ExperimentList } from '@/features/science/ExperimentList'
import { useDocumentMeta } from '@/hooks/useDocumentMeta'
import { useI18n } from '@/i18n'

export function SciencePage() {
  const { t } = useI18n()
  useDocumentMeta({ title: t.science.heading, description: t.science.lead })

  return (
    <Section>
      <SectionHeading eyebrow={t.science.eyebrow} title={t.science.heading} lead={t.science.lead} />
      <div className="mt-6">
        <Notice>{t.science.placeholderNotice}</Notice>
      </div>
      <div className="mt-10">
        <ExperimentList />
      </div>
    </Section>
  )
}
